import application, { definitionsFromContext } from "lib/stimulus"

const context = require.context("./", true, /\.js$/)
application.load(definitionsFromContext(context))
